/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 9/18/18 1:01 PM
 * Created by kxian
 *
 */
import React, {Component} from "react";
import BootstrapDialog from "./bootstrap-dialog";
import {$} from "./ext-refs";

/**
 * This component provides a popup modal to prompt the user
 * if they want to continue their session or log out from the application.
 *
 * parameters:
 * secondsUntilWarning - the number of seconds before the prompt modal will be displayed
 * warningDurationSeconds - the number of seconds after the modal is displayed and the onWarningTimeout will be executed
 * if the user doesn't select any options in the modal
 * onWarningTimeout - a function to be executed if the user doesn't select any options in the modal
 * onLogout - a function to be executed if the user selects logout in the modal
 * onContinueSession - a function to be executed if the user selects continue session in the modal
 * config
 *
 * secondsUntilWarning={sessionTimeoutSeconds - 70}
 *  warningDurationSeconds={60}
 *
 */
class SessionTimeoutWidget extends Component {

    constructor(props) {
        super(props);
        const {state} = this.props;
        const {config} = state;

        this.warningDurationSeconds = (this.props.warningDurationSeconds || 60);
        this.secondsUntilWarning = config.sessionTimeoutSeconds - 70;

        console.log('Initializing SessionTimeoutWidget: secondsUntilWarning=' + this.secondsUntilWarning +
            ', warningDurationSeconds=' + this.warningDurationSeconds);

        this.setTimers = this.setTimers.bind(this);
        this.clearTimers = this.clearTimers.bind(this);
        this.warn = this.warn.bind(this);
        this.startCountdown = this.startCountdown.bind(this);
        this.state = {
            showWarning: false,
            secondsUntilWarningTimer: 0,
            onWarningTimeoutTimer: 0
        };
        this.onContinueSession = this.onContinueSession.bind(this);
        this.onWarningTimeout = this.onWarningTimeout.bind(this);
        this.onLogout = this.onLogout.bind(this);
    }

    componentDidMount() {
        this.setTimers();
    }

    componentWillUnmount() {
        this.clearTimers();
    }

    // If the resetSessionTimeoutWarning value is true, then refresh the current session in AD.
    componentDidUpdate() {
        const {state} = this.props;
        // resetSessionTimeoutWarning will be set true only, when submitting payment by XOTP calls.
        const resetSessionTimeoutWarning = state.getValue('resetSessionTimeoutWarning');
        if (resetSessionTimeoutWarning) {
            this.onContinueSession();
        }
    }

    setTimers() {
        let secondsUntilWarningTimer = setTimeout(this.warn, this.secondsUntilWarning * 1000);
        this.setState({
            secondsUntilWarningTimer
        })
    };

    warn() {
        this.setState({showWarning: true});
        let onWarningTimeoutTimer = setTimeout(this.onWarningTimeout, this.warningDurationSeconds * 1000);
        this.setState({
            onWarningTimeoutTimer
        });
        this.startCountdown();
    }

    startCountdown() {
        this.setState({
            secondsCounter: this.warningDurationSeconds
        });
        let countdownTimer = setInterval(() => {
            this.setState({
                    countdownTimer,
                    secondsCounter: this.state.secondsCounter - 1
                }
            );
            if (this.state.secondsCounter <= 0) {
                clearInterval(countdownTimer);
            }
        }, 1000);
    }

    clearTimers() {
        clearInterval(this.state.countdownTimer);
        delete this.state.countdownTimer;
        clearTimeout(this.state.secondsUntilWarningTimer);
        delete this.state.secondsUntilWarningTimer;
        clearTimeout(this.state.onWarningTimeoutTimer);
        delete this.state.onWarningTimeoutTimer;
        delete this.state.secondsCounter;
    }

    // callbacks
    // onContinueSession
    // onWarningTimeout
    // onLogout

    onContinueSession() {
        this.clearTimers();
        this.setState({showWarning: false});

        const {state, sessionUpdateUrl} = this.props;
        const {config} = state;

        state.setValue('resetSessionTimeoutWarning', false);
        // do an Ajax call to the backend to refresh the session and get a new jwt token for xotp
        $.ajax({
            method: 'POST',
            url: `${sessionUpdateUrl}?CSRF_TOKEN=${encodeURIComponent(config.csrf)}`,
            dataType: "json",
            success: (data) => {
                // update jwt tokens in the state
                const {jwtToken} = data;
                state.setValues((data) => {
                    data.nginxJwtToken = jwtToken;
                    return data;
                });
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log('Error: ', jqXHR, textStatus, errorThrown);
                // if refreshing the session failed, then just log out
                this.logout();
            }
        });
        this.setTimers();
    }

    onWarningTimeout() {
        this.clearTimers();
        this.setState({showWarning: false});
        // warning timed out, call logout
        this.onLogout();
    }

    /**
     * Explicit logout by user.
     */
    onLogout() {
        this.clearTimers();
        this.setState({showWarning: false});
        const {state, logoutUrl} = this.props;
        const {config} = state;
        const {paymentConfig} = config;

        window.location = `${logoutUrl}?client=${paymentConfig.client}&CSRF_TOKEN=${encodeURIComponent(config.csrf)}`;
    }


    render() {
        const {state} = this.props;
        const {config} = state;
        const {messages} = config;

        return this.state.showWarning && (
            <BootstrapDialog
                className="modal mdb-modal fade"
                aria-labelledby="modal-session-timeout"
                aria-hidden="true"
                keyboard={false}>
                <div className="modal-dialog modal-notify modal-danger" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modal-session-timeout">
                                {messages["sessionTimeoutWidget.title"]}
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <p>
                                        {messages["sessionTimeoutWidget.msg"]}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer align-button-between-left">
                            <button
                                type="button"
                                className="btn btn-danger waves-effect btn-modal-cancel"
                                data-dismiss="modal"
                                onClick={this.onLogout}>
                                {messages["sessionTimeoutWidget.logout"]}
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-danger waves-effect btn-modal-confirm"
                                data-dismiss="modal"
                                onClick={this.onContinueSession}>
                                {`${messages["sessionTimeoutWidget.continue"]}(${this.state.secondsCounter})`}
                            </button>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }
}


export default SessionTimeoutWidget;